import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { withTheme, Box, AppBar, Hidden, Divider, Popover, useTheme, Typography, Fade } from '@material-ui/core';
import { Close, CheckRounded, ImportExport, Create, KeyboardArrowDown, FavoriteSharp  } from '@material-ui/icons';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import styled, { css } from 'styled-components';
import { useStore } from '../../../mobx-store';
import LRLink from '../../../components/LRLink';
import LRButton from '../../../components/LRButton';
import LRSelect from '../../../components/LRSelect';
import LRAvatar from '../../../components/LRAvatar';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useBoardCards } from '../../../hooks/useBoardCards';
import { useResponsiveBreakpoint } from '../../../hooks';
import analytics from '../../../services/analytics';
import { Can } from '../../../components/Ability';
import { subject } from '@casl/ability';
import { useAbility } from '../../../components/Ability';
import { useOnboarding } from '../../../components/Onboarding';
import { COLOR_STEAK_SAUCE } from '../../../constants';
import { useBoardListpacks } from 'hooks/useBoardListpacks';


const sortOptions = [
    {id: 'columnIndex', label: 'Column Order'},
    {id: 'listing_details.listing_date', label: 'Days on market', order: 'desc'},
    {id: 'listing_details.year', label: 'Year built', order: 'desc'},
    {id: 'listing_details.price', label: 'Price (high to low)', order: 'desc'},
    {id: 'listing_details.price', label: 'Price (low to high)', order: 'asc'},
    {id: 'listing_details.beds', label: 'Most bedrooms', order: 'desc'},
    {id: 'listing_details.baths', label: 'Most bathrooms', order: 'desc'},
    {id: 'listing_details.home_size', label: 'Most square feet', order: 'desc'},
    {id: (l)=> l.listing_details.open_houses[0]?.date_iso || '1970-01-01' , label: 'Open house', order: 'desc'},
];

const listpackSortOptions = [
    'Days on market (default)',
    'Year built',
    'Price (high to low)',
    'Price (low to high)',
    'Most bedrooms',
    'Most bathrooms',
    'Most square feet',
    'Open house',
];

const DesktopPopover = styled(Popover)`
    .MuiPopover-paper {
        max-width: 360px;
        width: 100%;
        box-shadow: -5px 5px 5px -5px rgba(0, 0, 0, 0.4);
        border-radius: unset;
    }
`;

const StyledDesktopPopover = styled(Popover)`
    .MuiPopover-paper {
        max-width: 360px;
        max-height: 100px;
        overflow: auto;
        width: 100%;
        box-shadow: -5px 5px 5px -5px rgba(0, 0, 0, 0.4);
        border-radius: unset;
    }
`;

const FilterButton = withTheme(styled(ToggleButton)`
    min-width: 160px;
    height: 40px;
    text-transform: capitalize;

    ${({ theme })=> css`
        color: ${theme.palette.text.primary};
        &.Mui-selected {
            color: ${theme.palette.text.primary};
            background-color: ${theme.palette.grey[300]};
        }
    `}
`);

const StyledLRSelect = styled(LRSelect)`
    select {
        line-height: 1;
        font-size: 16px;
        padding: 14px 8px 15px 8px;
        border-color: #ddd;
        width: 100%;

        &:focus {
            border-color: #ddd;

        }
    }
`;

export function DesktopSortPopover({ anchorEl, setAnchorEl, sort, setSort }) {
    const theme = useTheme();

    return (
        <DesktopPopover
            id="desktop-sort"
            keepMounted
            open={Boolean(anchorEl)}
            onClose={()=> setAnchorEl(null)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <Box px="16px" py="10px" color={theme.palette.lr_colors.grey_nero}>
                {sortOptions.map(function(option, index) {
                    return (
                        <Box
                            style={{ cursor: 'pointer' }}
                            key={index}
                            onClick={()=> {
                                setSort(option);
                                setAnchorEl(null);
                            }}
                        >
                            {index !== 0 && (
                                <Box margin="10px 0">
                                    <Divider />
                                </Box>
                            )}
                            <Box
                                display="flex"
                                height="24px"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box ml={1} fontSize="body1.fontSize">
                                    {option.label}
                                </Box>
                                {sort?.label === option.label && (
                                    <Box height="24px" color="#54D0AA">
                                        <CheckRounded />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </DesktopPopover>
    );
}

export function ListpackSortPopover({ anchorEl, setAnchorEl, sort, setSort }) {
    const theme = useTheme();

    return (
        <DesktopPopover
            id="desktop-sort"
            keepMounted
            open={Boolean(anchorEl)}
            onClose={()=> setAnchorEl(null)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <Box px="16px" py="10px" color={theme.palette.lr_colors.grey_nero}>
                {listpackSortOptions.map(function(option, index) {
                    return (
                        <Box
                            style={{ cursor: 'pointer' }}
                            key={index}
                            onClick={()=> {
                                setAnchorEl(null);
                                setSort(option);
                            }}
                        >
                            {index !== 0 && (
                                <Box margin="10px 0">
                                    <Divider />
                                </Box>
                            )}
                            <Box
                                display="flex"
                                height="24px"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box ml={1} fontSize="body1.fontSize">
                                    {option}
                                </Box>
                                {sort === option && (
                                    <Box height="24px" color="#54D0AA">
                                        <CheckRounded />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </DesktopPopover>
    );
}

const DesktopListpackPopover = observer(({ anchorEl, setAnchorEl, currentListpackId, onChange })=> {
    const theme = useTheme();
    const { listpacks } = useBoardListpacks();
    const isXs = useResponsiveBreakpoint('xs');

    return (
        <StyledDesktopPopover
            id="desktop-listpack-popover"
            keepMounted
            open={Boolean(anchorEl)}
            onClose={()=> setAnchorEl(null)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: isXs ? 'right' : 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: isXs ? 'right' : 'left',
            }}
        >
            <Box px="16px" py="10px" maxHeight={300} overflow="auto" color={theme.palette.lr_colors.grey_nero}>
                {listpacks?.map(function(listpack, index) {
                    return (
                        <Box
                            style={{ cursor: 'pointer' }}
                            key={index}
                            onClick={(e)=> {
                                analytics.eventTrack('robin_expanded_view_saved_search_toggle_selected');
                                setAnchorEl(null);
                                onChange(listpack);
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                        >
                            {index !== 0 && (
                                <Box margin="10px 0">
                                    <Divider />
                                </Box>
                            )}
                            <Box
                                display="flex"
                                height="24px"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box ml={1} fontSize="body1.fontSize">
                                    {listpack?.name}
                                </Box>
                                {listpack?.id === currentListpackId && (
                                    <Box height="24px" color="#54D0AA">
                                        <CheckRounded />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </StyledDesktopPopover>
    );
});

export const Navbar = observer(({ currentFilter, onFilterChange, onSortChange, sort, onClose })=> {
    const { LanesStore, boardsStore, UserStore } = useStore();
    const { lanes } = LanesStore;
    const [anchorEl, setAnchorEl] = useState(null);
    const isXs = useResponsiveBreakpoint('xs');
    const onboarding = useOnboarding();
    const history = useHistory();
    const {
        getUnarchivedBoardCardsByLaneId,
    } = useBoardCards();

    function handleFilterChange(e) {
        const laneId = e.currentTarget.value;
        const lane = lanes.find((l)=> { return l.id === laneId; });

        var source;
        switch(laneId) {
            case '1':
                source = 'interested';
                break;
            case '2':
                source = 'want_to_see';
                break;
            default:
                source = 'want_to_buy';
                break;
        }

        analytics.eventTrack('robin_expanded_view_column_toggled_button_click', {
            column: lane?.name.toLowerCase(),
            source: source,
        });

        onFilterChange(e);
    }

    function handleOnClose() {
        if(onClose) {
            onClose();
        } else {
            history.push('/boards');
        }
    }

    return (
        <Box position="relative" px={[2,4]} py={[1,2]} bgcolor="#fff">
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Hidden smDown>
                    <Box>
                        <ToggleButtonGroup value={currentFilter} onChange={handleFilterChange}>
                            {
                                lanes.map((lane)=> {
                                    const laneCards = getUnarchivedBoardCardsByLaneId(lane.id);
                                    return (<FilterButton disabled={laneCards.length === 0} value={lane.id}>{lane.name} ({laneCards.length})</FilterButton>);
                                })
                            }
                        </ToggleButtonGroup>
                    </Box>
                </Hidden>
                <Hidden mdUp>
                    <Box>
                        <StyledLRSelect
                            fullWidth={true}
                            native={true}
                            value={currentFilter}
                            onChange={handleFilterChange}
                        >
                            {
                                lanes.map((lane)=> {
                                    const laneCards = getUnarchivedBoardCardsByLaneId(lane.id);
                                    return  (<option value={lane.id} disabled={laneCards.length === 0}>{lane.name} {laneCards.length}</option>);
                                })
                            }
                        </StyledLRSelect>
                    </Box>
                </Hidden>
                <Box display="flex">
                    {
                        !isXs && (
                            <Box>
                                <LRButton fullWidth variant="outlined" onClick={(e)=> setAnchorEl(e.currentTarget)}>
                                    <ImportExport fontSize="inherit" />
                                    <Box component="span" ml={0.5}>
                                        Sort
                                    </Box>
                                </LRButton>
                                <DesktopSortPopover
                                    anchorEl={anchorEl}
                                    setAnchorEl={setAnchorEl}
                                    sort={sort}
                                    setSort={onSortChange}
                                />
                            </Box>
                        )
                    }

                    <Box ml={2} display="flex" alignItems="center" justifyContent="center">
                        <LRLink color="black" className="tour-target-modal-close-button tour-target-modal-close-button-mobile"
                            onClick={()=> {
                                handleOnClose();
                                onboarding.next();
                            }}
                        >
                            <Close></Close>
                        </LRLink>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
});

export const OrganizerNavbar = observer(({ listpack, onSortChange, sort, onClose })=> {
    const { UserStore } = useStore();
    const { user } = UserStore;
    const [anchorEl, setAnchorEl] = useState(null);
    const [listpackAnchorEl, setListpackAnchorEl] = useState(null);
    const history = useHistory();
    const isXs = useResponsiveBreakpoint('xs');
    const onboarding = useOnboarding();
    const match = useRouteMatch();
    const listpackContentText = listpack?.preference_display ? listpack.preference_display.join(' • ') : '';
    const { isLoading:isLoadingListpacks, listpacks } = useBoardListpacks();

    function handleFREOnboarding(e) {
        const { tour, isFirstRunOnboarding, isNurtureFirstRunOnboarding } = onboarding || {};
        const { currentStep = {} } = tour || {};
        const { id } =  currentStep;

        if((isFirstRunOnboarding || isNurtureFirstRunOnboarding) && tour.isActive()) {
            switch(id) {
                case 'introduce-listpacks':
                    tour.next();
                    return false;
                case 'edit-option-highlight':
                    tour.next();
                    break;
                default:
                    return true;

            }
        }
        return true;
    }

    function handleOnEditClick() {
        const shouldContinue = handleFREOnboarding();
        if(!shouldContinue) return;

        const location = {
            pathname: `${match.url}/edit`,
            state: { from: history.location.pathname }
        };
        history.push(location);
    }

    function handleOnLispackChange(listpack) {
        const shouldContinue = handleFREOnboarding();
        if(!shouldContinue) return;

        history.push(`/boards/listpack/${listpack.id}/listings`);
    }

    function handleOnClose() {
        const shouldContinue = handleFREOnboarding();
        if(!shouldContinue) return;

        if(onClose) {
            onClose();
        } else {
            history.push(`${isXs ? '/boards/lane/0/your-searches' : '/boards'}`);
        }
    }

    function handleListpackToggle(e) {
        const shouldContinue = handleFREOnboarding();
        if(!shouldContinue) return;

        setListpackAnchorEl(e.currentTarget);
    }

    function handleOnSortClick(e) {
        const shouldContinue = handleFREOnboarding();
        if(!shouldContinue) return;

        setAnchorEl(e.currentTarget);
    }

    return (
        <Box position="relative" px={[2,4]} py={[1,2]} bgcolor="#fff" className="tour-target-listpack-name">
            <Box display="flex" justifyContent="space-between" alignItems="center">
                {isLoadingListpacks && (<Box display='flex' />)}

                <Fade in={!isLoadingListpacks && listpacks?.length}>
                    <Box display="flex" alignItems="center">
                        <Box>
                            {listpack?.creator && (
                                <LRAvatar user={listpack.handSelected ? user.affiliate : listpack.creator} />
                            )}
                        </Box>
                        <Box ml={1.5}>
                            <Box fontSize="16px" display="flex">
                                <Box display="flex">
                                    <Box display="flex" alignItems="center">
                                        { listpack?.name }
                                        {
                                            listpack?.handSelected && (
                                                <Box position="relative" top={2} ml={1}>
                                                    <svg width="84" height="15" viewBox="0 0 84 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.66572 2.85709C5.49258 3.42752 8.74966 7.01726 1.8777 8.66461C1.95663 7.08119 2.03029 5.48301 2.23551 3.91434C2.6775 3.57996 2.41441 2.25224 1.70932 2.62597C1.21471 4.59295 1.35678 6.73205 1.12526 8.73837C0.893737 8.80721 0.525409 8.76296 0.288626 8.85147C-0.516436 9.43173 0.562241 9.60384 1.09895 9.47107C1.20945 10.5283 0.572765 11.9298 1.1884 12.8297C1.64618 13.0018 1.8093 12.3773 1.90927 12.0773C1.48306 11.2659 1.90927 10.307 1.81982 9.42681C3.42468 9.0285 5.0769 8.44332 6.2345 7.26805C6.35553 8.17778 4.59281 13.1002 6.33974 12.5002C6.50655 10.3967 6.78754 8.30244 7.18163 6.22555C7.66046 5.30599 8.76019 3.63405 7.66572 2.85709ZM30.5179 0.280344C27.2608 0.403281 27.3608 6.18129 26.8346 8.4089C24.551 6.04852 23.2092 10.4939 21.0782 10.9217C19.8311 11.1725 20.9729 9.04817 20.6098 8.41874C19.9153 6.78614 18.1578 8.55642 17.5527 9.40223C17.6855 8.98502 17.7857 8.55936 17.8526 8.12861C17.8526 7.83356 17.1318 7.67128 17.0897 8.02534C15.8795 9.00883 14.9534 11.0447 13.2064 11.2069C12.333 10.7152 13.9641 6.33865 12.1541 8.0696C11.3595 9.05309 10.6597 10.371 9.41792 10.8283C9.05485 9.70219 10.0546 7.09102 11.6384 8.28596C12.7855 8.1827 11.2701 7.0566 10.6808 7.24838C7.08692 8.6351 8.30241 14.8459 12.2593 9.14652C12.3961 9.59893 11.8278 12.2396 13.6116 11.9052C14.9534 11.4577 15.9531 10.3267 16.8371 9.30879C16.8687 9.86447 15.99 11.4921 17.1686 11.202C17.879 10.2185 18.563 8.79738 19.8258 8.43841C20.2415 9.4219 19.0155 11.3889 20.6625 11.6692C21.8516 11.7085 22.7672 10.7152 23.5828 10.0366C23.7196 12.3183 26.2874 10.6562 26.9188 9.49566C27.003 10.4398 27.5397 11.8315 28.7973 11.6643C29.1393 11.5462 28.9604 10.9906 28.6131 11.0102C27.2713 10.489 27.3766 8.42365 28.2816 7.53851C29.0814 5.72889 32.4332 1.96703 30.5179 0.280344ZM26.3558 9.03833C22.9303 13.464 24.251 6.45667 26.4137 8.98424L26.3558 9.03833ZM30.3022 1.96703C29.776 3.77666 28.7236 5.40925 27.7712 7.0271C27.9364 5.43801 28.3165 3.8749 28.9025 2.37518C29.2024 1.43103 30.7915 -0.0343733 30.3022 1.96703ZM83.4152 0.280344C80.1581 0.403281 80.258 6.18129 79.7319 8.4089C78.1533 6.5206 76.78 8.90065 75.5908 9.84972C74.3753 10.9217 71.3287 11.8462 71.3498 9.44648C76.0854 8.67936 73.0125 4.352 70.8657 8.36464C70.8657 8.36464 70.7078 8.48758 70.7289 8.51217C68.8767 11.202 64.5936 13.9853 65.7196 8.41874C66.8509 7.43524 66.9614 6.23538 68.8399 6.82056C69.124 6.8599 69.2871 6.66812 69.3187 6.42717C69.3871 5.72397 68.1558 6.11737 67.6875 6.0141C68.6136 5.1142 68.6241 2.78825 66.793 3.79633C66.0774 4.37167 65.809 5.27156 65.5196 6.08786C65.141 6.04282 64.7583 6.03458 64.3778 6.06327C63.9148 5.96492 63.6149 6.60419 64.1621 6.70746C64.5446 6.74767 64.9295 6.76573 65.3144 6.76155C65.2145 7.2533 65.0671 7.7057 65.004 8.19253C59.0528 14.5508 57.348 8.49742 61.0944 8.25646C61.4365 8.34006 61.9205 8.34497 61.9205 7.9024C61.6364 7.49917 60.8682 7.49917 60.3788 7.58769C58.9529 7.94174 58.3899 9.4219 57.1586 10.0907C55.9431 11.0742 53.1964 11.6249 53.2701 9.44648C57.8374 8.77279 55.1696 4.40117 52.8386 8.23187C52.786 8.26629 52.7229 8.31055 52.7439 8.33022C51.3969 9.59893 47.6662 13.2772 47.5715 9.26454C49.2763 6.88449 51.0391 4.1258 51.2758 1.12123C49.0869 -3.35366 46.5981 6.90416 46.8559 8.49741C45.6825 9.97265 41.4888 12.7658 41.1205 9.4514C45.5404 8.85147 43.2252 4.46018 40.7311 8.13352C39.4527 8.74642 38.2328 9.46041 37.0847 10.2677C36.4427 9.14652 36.0323 9.28421 37.3583 8.54659C38.3212 7.75488 36.9531 6.79106 36.1481 7.50901C35.1694 8.6056 36.1796 8.80721 34.117 9.08751C33.8592 9.17111 33.3698 9.08751 33.354 9.4219C33.3225 10.3218 35.1325 9.51041 35.6482 9.39239C36.027 9.57926 36.1744 10.3759 36.4953 10.7054C35.3693 11.3545 33.7171 13.9509 36.0586 14.005C37.5635 13.7984 38.1002 12.038 37.4319 10.9119C38.3518 10.2001 39.3501 9.58189 40.4102 9.06784C40.1892 10.2431 40.9363 11.5266 42.2886 11.6888C44.0882 11.7528 45.6246 10.6267 46.8454 9.50058C46.9138 10.3365 47.1085 11.3446 48.0346 11.7036C49.8341 12.1953 51.3127 10.4742 52.5387 9.48091C52.5006 10.0039 52.6742 10.5211 53.0251 10.9301C53.376 11.3391 53.8785 11.6099 54.4329 11.6888C55.9484 11.738 57.3638 10.9365 58.4319 9.97265C58.7371 13.5919 63.4307 10.9561 64.8356 9.37272C64.6883 10.4791 64.8356 12.0478 66.2405 12.3527C68.2137 12.4855 69.3187 11.084 70.6236 9.77595C70.6544 10.2491 70.8585 10.6979 71.2015 11.0471C71.5445 11.3964 72.0056 11.6247 72.5074 11.6938C74.0123 11.7429 75.4119 10.9512 76.4748 10.012C76.5642 12.3281 79.1794 10.6857 79.8108 9.52025C79.895 10.4644 80.4317 11.856 81.6945 11.6888C82.0366 11.5708 81.8577 11.0152 81.5104 11.0348C80.1686 10.5136 80.2738 8.44824 81.1789 7.5631C81.9787 5.72889 85.3305 1.96703 83.4152 0.280344ZM71.5602 8.6056C71.6129 8.03026 73.5176 6.57469 73.0967 7.89257C72.8283 8.16303 71.6234 9.01375 71.5602 8.6056ZM66.5194 5.56169C66.5194 5.03553 67.9506 3.40293 67.5718 4.7749C67.2876 5.26665 67.0929 6.20588 66.3405 6.03869C66.3782 5.87627 66.4292 5.71681 66.4931 5.56169H66.5194ZM66.0564 6.83531C66.0564 6.69763 66.2037 6.73205 66.3089 6.74188C66.2207 6.87692 66.1166 7.00228 65.9985 7.11561C66.001 7.02154 66.0115 6.92781 66.03 6.83531H66.0564ZM53.4806 8.6056C53.5332 8.03026 55.438 6.57469 55.017 7.89257C54.7487 8.16303 53.5437 9.01375 53.4542 8.6056H53.4806ZM47.6925 7.50901C49.1869 -2.89633 53.1912 0.0787285 47.6925 7.88765C47.6768 7.7598 47.6662 7.63686 47.6768 7.50901H47.6925ZM41.3099 8.6056C41.3625 8.03026 43.2673 6.57469 42.8464 7.89257C42.6201 8.16303 41.3994 9.01375 41.3099 8.6056ZM36.4006 8.32039C36.7953 7.51884 37.232 7.96141 36.4006 8.32039V8.32039ZM36.9268 12.4265C36.8836 12.6655 36.757 12.8844 36.5666 13.049C36.3762 13.2136 36.1328 13.3146 35.8744 13.3362C35.0641 12.8444 36.4006 11.7429 36.8637 11.3692C36.9489 11.5327 36.998 11.7107 37.0079 11.8923C37.0179 12.074 36.9885 12.2557 36.9215 12.4265H36.9268ZM79.2583 9.03833C77.8902 11.0496 76.1907 11.0053 77.8534 8.57118C78.3796 8.11385 78.9742 8.61052 79.3162 8.98424L79.2583 9.03833ZM83.1994 1.96703C82.6732 3.77666 81.6209 5.40925 80.6685 7.0271C80.8331 5.43744 81.215 3.87406 81.805 2.37518C82.0839 1.43103 83.6888 -0.0343733 83.1994 1.96703Z" fill="#231F20"/>
                                                    </svg>
                                                </Box>
                                            )
                                        }
                                    </Box>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        onClick={(e)=> {handleListpackToggle(e);}}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <KeyboardArrowDown />
                                    </Box>
                                </Box>
                            </Box>
                            <Box fontSize="12px" color="#A1A1A1">{listpack?.handSelected ? (listpack?.listpackCards?.length || 0 ) : listpack?.activeListingsCount || 0} homes</Box>
                        </Box>
                        <DesktopListpackPopover
                            currentListpackId={listpack?.id}
                            anchorEl={listpackAnchorEl}
                            setAnchorEl={setListpackAnchorEl}
                            onChange={handleOnLispackChange}
                        />
                    </Box>
                </Fade>


                <Box display="flex">
                    { (listpack?.handSelected ? !!listpack.listpackCards?.length : !!listpack?.activeListingsCount) && (
                        <Hidden smDown>
                            <Box
                                display="flex"
                                color={COLOR_STEAK_SAUCE}
                                mr={1}
                                alignItems="center"
                            >
                                <Typography
                                    variant="caption"
                                    style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow:  'ellipsis',
                                        maxWidth: '450px',
                                    }}
                                >
                                    {listpackContentText}
                                </Typography>
                            </Box>

                            <Can I="edit" this={subject('Listpack', listpack)}>
                                <Box mr={1}>
                                    <LRButton fullWidth variant="outlined" onClick={handleOnEditClick} className="tour-fre-edit-highlight">
                                        <Create fontSize="inherit" />
                                        <Box component="span" ml={0.5}>
                                            Edit
                                        </Box>
                                    </LRButton>
                                </Box>
                            </Can>

                            <Box>
                                <LRButton fullWidth variant="outlined" onClick={(e)=> handleOnSortClick(e)}>
                                    <ImportExport fontSize="inherit" />
                                    <Box component="span" ml={0.5}>
                                        Sort
                                    </Box>
                                </LRButton>
                                {
                                    listpack && !listpack.handSelected ? (
                                        <ListpackSortPopover
                                            anchorEl={anchorEl}
                                            setAnchorEl={setAnchorEl}
                                            sort={sort}
                                            setSort={onSortChange}
                                        />
                                    ) : (
                                        <DesktopSortPopover
                                            anchorEl={anchorEl}
                                            setAnchorEl={setAnchorEl}
                                            sort={sort}
                                            setSort={onSortChange}
                                        />
                                    )
                                }
                            </Box>
                        </Hidden>
                    )}

                    <Box ml={2} display="flex" alignItems="center" justifyContent="center">
                        <LRLink color="black" className="tour-target-modal-close-button-mobile tour-target-modal-close-button"
                            onClick={()=> {
                                const shouldContinue = handleFREOnboarding();
                                if(!shouldContinue) {
                                    return;
                                }
                                handleOnClose();
                                onboarding.next();
                            }}
                        >
                            <Close></Close>
                        </LRLink>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
});
